export const resourceSections = [
    { id: 'older-adults', title: 'For Older Adults', description: 'Everyday information for staying active, connected, and independent.' },
    { id: 'caregivers', title: 'For Caregivers', description: 'Support for caring for someone else and looking after yourself.' }
];
